import { parseTimeFromSeconds } from "../parseTimeFromSeconds";
/**
 * @return {string} Formated string MM'
 * @param {number} ms Milliseconds to convert
 */
export var parseTimeFromMilliseconds = function (ms) {
    var toSeconds = Math.ceil(Math.abs(ms) / 1000);
    return parseTimeFromSeconds(toSeconds);
};
//# sourceMappingURL=parseTimeFromMilliseconds.js.map